<template>
    <div class='table-box'>
      <globalTag>
        <el-form
          class="queryForm"
          ref="queryForm"
          :model="queryForm"
          label-width="120px"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="套餐名称：">
                <el-input
                  clearable
                  v-model="queryForm.serveproductName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="15">
              <el-form-item label="受理时间：">
                <el-date-picker
                  v-model="queryForm.timeStart"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
                  type="datetime"
                  placeholder="请选择开始时间"
                ></el-date-picker>
                <span style="margin: 0 5px">至</span>
                <el-date-picker
                  v-model="queryForm.timeEnd"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
                  type="datetime"
                  placeholder="请选择结束时间"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-button
                size="medium"
                type="primary"
                @click="QuerySearch"
              >查询</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </globalTag>


        <div>
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="servicePgds"
                    label="工单数量"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="referTime"
                    label="工时"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="productprice"
                    label="价格/元"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="referTimes"
                    label="总工时"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="productprices"
                    label="总价格/元"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import globalTag from "@/component/globalTag"

import headLine from "../../components/headline"
export default {
    components: {
        globalTag,

        headLine,
    },
    data() {
        return {
            showVisit: false,
            queryForm: {},
            tableData: [],
            isSearchContent: true,
        }
    },
    created() {
        this.getDataList()
    },
    methods: {
        Reset() {
            this.queryForm = {}
            this.getDataList()
        },
        getDataList() {
            let params = {
                timeStart: this.queryForm.timeStart,
                timeEnd: this.queryForm.timeEnd,
                serveproductName: this.queryForm.serveproductName,
                provinceId: this.queryForm.provinceId,
                cityId: this.queryForm.cityId,
                areaId: this.queryForm.areaId,
                streetId: this.queryForm.streetId,
                communityId: this.queryForm.communityId,
            }
            request({
                url: "/jjyl/servicePgd/info/findServicePgdStatistics",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content) {
                        this.tableData = res.content
                    } else {
                        this.tableData = []
                    }
                }
            })
        },

        QuerySearch() {
            this.getDataList()
        },
    },
}
</script>

<style lang="less" scoped>
.table-operation {
    width: 100%;
    display: flex;
    cursor: pointer;
    justify-content: space-between;
}
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
</style>
